export const getMediaContents = [
  {
    _id: '64d127625ab1d500195f56e7',
    caption: 'Legenda reels',
    createdAt: '2023-08-07T17:18:26.890Z',
    idCampaign: '64807ee4ba29ffe157064bd2',
    medias: [
      {
        link: 'https://storage.googleapis.com/squid-content-approval/64807ee4ba29ffe157064bd2/7b2f14011feb/26e90087-71ec-46df-bd18-0703b1772a44.mp4',
        thumbnail:
          'https://storage.googleapis.com/squid-content-approval/64807ee4ba29ffe157064bd2/7b2f14011feb/c0460082-e335-43c3-bd90-5eff00dbb2d0.png',
        type: 'video',
      },
    ],
    socialId: '17841400894450374',
    socialNetworks: ['instagram'],
    squidId: '7b2f14011feb',
    stage: 'before',
    status: 'finalReproved',
    type: 'reels',
    updatedAt: '2023-08-07T17:18:44.366Z',
    final: {
      reviewer: 'heloisa.giradi@squidit.com.br',
      comment: 'não passou reels',
      status: 'finalReproved',
      updatedAt: '2023-08-07T17:18:44.366Z',
      createdAt: '2023-08-07T17:18:44.366Z',
    },
  },
  {
    _id: '64d1274dec4831001aef050c',
    caption: 'Teste post',
    createdAt: '2023-08-07T17:18:05.232Z',
    idCampaign: '64807ee4ba29ffe157064bd2',
    medias: [
      {
        link: 'https://storage.googleapis.com/squid-content-approval/64807ee4ba29ffe157064bd2/7b2f14011feb/8482f823-8f9b-4a63-86a4-44a373e26637.jpg',
        thumbnail:
          'https://storage.googleapis.com/squid-content-approval/64807ee4ba29ffe157064bd2/7b2f14011feb/8482f823-8f9b-4a63-86a4-44a373e26637.jpg',
        type: 'image',
      },
    ],
    socialId: '17841400894450374',
    socialNetworks: ['instagram'],
    squidId: '7b2f14011feb',
    stage: 'before',
    status: 'finalReproved',
    type: 'post',
    updatedAt: '2023-08-07T17:18:53.949Z',
    final: {
      reviewer: 'heloisa.giradi@squidit.com.br',
      comment: 'não passou post',
      status: 'finalReproved',
      updatedAt: '2023-08-07T17:18:53.949Z',
      createdAt: '2023-08-07T17:18:53.949Z',
    },
  },
  {
    _id: '64d1248926ad48001852c25f',
    caption: 'Legenda bla bla bla',
    createdAt: '2023-08-07T17:06:17.440Z',
    idCampaign: '64807ee4ba29ffe157064bd2',
    medias: [
      {
        link: 'https://storage.googleapis.com/squid-content-approval/64807ee4ba29ffe157064bd2/7b2f14011feb/8aee9532-4767-4a60-87d6-c4e6559ca245.jpg',
        thumbnail:
          'https://storage.googleapis.com/squid-content-approval/64807ee4ba29ffe157064bd2/7b2f14011feb/8aee9532-4767-4a60-87d6-c4e6559ca245.jpg',
        type: 'image',
      },
    ],
    socialId: '17841400894450374',
    socialNetworks: ['instagram'],
    squidId: '7b2f14011feb',
    stage: 'before',
    status: 'finalReproved',
    type: 'story',
    updatedAt: '2023-08-07T17:19:07.955Z',
    final: {
      reviewer: 'heloisa.giradi@squidit.com.br',
      comment: 'não passou story',
      status: 'finalReproved',
      updatedAt: '2023-08-07T17:19:07.955Z',
      createdAt: '2023-08-07T17:19:07.955Z',
    },
  },
]

export const generateSignedURL = [
  {
    file: {
      extension: 'png',
      contentType: 'image/png',
      fileName: 'chucknorris.png',
    },
    postUrl: {
      signedURL:
        'https://storage.googleapis.com/squid-content-approval/64807ee4ba29ffe157064bd2/7b2f14011feb/f143003d-b5c3-4ade-a8d9-969d07fc722b.png?X-Goog-Algorithm=GOOG4-RSA-SHA256&X-Goog-Credential=api-edna%40squid-apis.iam.gserviceaccount.com%2F20230827%2Fauto%2Fstorage%2Fgoog4_request&X-Goog-Date=20230827T012337Z&X-Goog-Expires=3600&X-Goog-SignedHeaders=content-type%3Bhost&X-Goog-Signature=c00d65ecd25ab55422f5295636408cd59296f0f61ad63a6d213c7183f1a76d0bac9df4964d3df4ecd791158c1a8cf2d46ec2c347854228a23f5e0557bece7c05068d4accdf7e1d4fb348afcc296b9db6a0d35d3458063e4c1f4cd384b0004ea0bf4f42edd1627627558d80fcf026d114d335652cca736cb91b45da5e07beaec34b93c45023c97ef6599029eef5b3a3a7e07339353f0f035d8535dbcc5d13f14cd523946fa86c21aca0f3af5ee92ed6d077e21b8ac9729a313d09647d52cb7889d8a1a58a7ce693941b4aefbbdf049f17aff23e5fa79b03912a1e8809a9fd34330bd3c90c091d02d80e15b8bedfb8efa763120dee55cce3502bd6c4b10ebf5ab5',
      publicURL:
        'https://storage.googleapis.com/squid-content-approval/64807ee4ba29ffe157064bd2/7b2f14011feb/f143003d-b5c3-4ade-a8d9-969d07fc722b.png',
    },
  },
]
